export const WEBSITE_NAVIGATOR_UI_PRESETS = {
  "version": 1,
  "navigator_shortcut_modules": [
    {
      "module_id": "assistance",
      "module_type": "target",
      "name": "Assistance",
      "description": "Answers visitor questions from approved Weros knowledge inside the navigator.",
      "open_behavior": "assistance",
      "shortcut": {
        "enabled": true,
        "order": 10,
        "label": "Assistance",
        "label_i18n": {
          "en": "Assistance",
          "de": "Assistenz"
        },
        "icon": "message-circle",
        "description": "Ask questions and get grounded answers from Weros knowledge.",
        "description_i18n": {
          "en": "Ask questions and get grounded answers from Weros knowledge.",
          "de": "Stelle Fragen und erhalte fundierte Antworten aus dem Weros-Wissen."
        }
      }
    },
    {
      "module_id": "find_right_service",
      "module_type": "target",
      "name": "Find right Service",
      "description": "Hosts service advice, comparison and answering flows in one visible navigator module.",
      "open_behavior": "service",
      "shortcut": {
        "enabled": true,
        "order": 20,
        "label": "Find right Service",
        "label_i18n": {
          "en": "Find right Service",
          "de": "Passende Leistung finden"
        },
        "icon": "search-check",
        "description": "Describe your situation, compare services and find the Weros service that fits.",
        "description_i18n": {
          "en": "Describe your situation, compare services and find the Weros service that fits.",
          "de": "Beschreibe deine Situation, vergleiche Leistungen und finde den passenden Weros-Service."
        }
      }
    },
    {
      "module_id": "contact",
      "module_type": "target",
      "name": "Contact",
      "description": "Hosts contact questions and inquiry handoff in one visible navigator module.",
      "open_behavior": "contact",
      "shortcut": {
        "enabled": true,
        "order": 30,
        "label": "Contact us",
        "label_i18n": {
          "en": "Contact us",
          "de": "Kontakt aufnehmen"
        },
        "icon": "mail",
        "description": "Send your request with the relevant context so our team can respond precisely.",
        "description_i18n": {
          "en": "Send your request with the relevant context so our team can respond precisely.",
          "de": "Sende deine Anfrage mit relevantem Kontext, damit unser Team gezielt antworten kann."
        }
      }
    },
    {
      "module_id": "appointment",
      "module_type": "target",
      "name": "Appointment",
      "description": "Hosts appointment questions and booking flow in one visible navigator module.",
      "open_behavior": "booking",
      "shortcut": {
        "enabled": true,
        "order": 40,
        "label": "Book Appointment",
        "label_i18n": {
          "en": "Book Appointment",
          "de": "Termin buchen"
        },
        "icon": "calendar-check",
        "description": "Choose a 30 minute consultation slot and provide the details needed for preparation.",
        "description_i18n": {
          "en": "Choose a 30 minute consultation slot and provide the details needed for preparation.",
          "de": "W\u00e4hle einen 30-min\u00fctigen Beratungstermin und gib die n\u00f6tigen Details zur Vorbereitung an."
        }
      }
    }
  ],
  "navigator_disabled_shortcut_module_ids": [
    "page_guidance",
    "website_check"
  ],
  "default_phone_country": "DE",
  "phone_countries": [
    {
      "code": "DE",
      "name": "Germany",
      "dial": "+49"
    },
    {
      "code": "AT",
      "name": "Austria",
      "dial": "+43"
    },
    {
      "code": "CH",
      "name": "Switzerland",
      "dial": "+41"
    },
    {
      "code": "CY",
      "name": "Cyprus",
      "dial": "+357"
    },
    {
      "code": "NL",
      "name": "Netherlands",
      "dial": "+31"
    },
    {
      "code": "BE",
      "name": "Belgium",
      "dial": "+32"
    },
    {
      "code": "FR",
      "name": "France",
      "dial": "+33"
    },
    {
      "code": "ES",
      "name": "Spain",
      "dial": "+34"
    },
    {
      "code": "IT",
      "name": "Italy",
      "dial": "+39"
    },
    {
      "code": "PT",
      "name": "Portugal",
      "dial": "+351"
    },
    {
      "code": "IE",
      "name": "Ireland",
      "dial": "+353"
    },
    {
      "code": "GB",
      "name": "United Kingdom",
      "dial": "+44"
    },
    {
      "code": "DK",
      "name": "Denmark",
      "dial": "+45"
    },
    {
      "code": "NO",
      "name": "Norway",
      "dial": "+47"
    },
    {
      "code": "SE",
      "name": "Sweden",
      "dial": "+46"
    },
    {
      "code": "FI",
      "name": "Finland",
      "dial": "+358"
    },
    {
      "code": "PL",
      "name": "Poland",
      "dial": "+48"
    },
    {
      "code": "CZ",
      "name": "Czechia",
      "dial": "+420"
    },
    {
      "code": "SK",
      "name": "Slovakia",
      "dial": "+421"
    },
    {
      "code": "HU",
      "name": "Hungary",
      "dial": "+36"
    },
    {
      "code": "SI",
      "name": "Slovenia",
      "dial": "+386"
    },
    {
      "code": "HR",
      "name": "Croatia",
      "dial": "+385"
    },
    {
      "code": "RO",
      "name": "Romania",
      "dial": "+40"
    },
    {
      "code": "BG",
      "name": "Bulgaria",
      "dial": "+359"
    },
    {
      "code": "GR",
      "name": "Greece",
      "dial": "+30"
    },
    {
      "code": "LU",
      "name": "Luxembourg",
      "dial": "+352"
    },
    {
      "code": "MT",
      "name": "Malta",
      "dial": "+356"
    },
    {
      "code": "EE",
      "name": "Estonia",
      "dial": "+372"
    },
    {
      "code": "LV",
      "name": "Latvia",
      "dial": "+371"
    },
    {
      "code": "LT",
      "name": "Lithuania",
      "dial": "+370"
    },
    {
      "code": "US",
      "name": "United States",
      "dial": "+1"
    },
    {
      "code": "CA",
      "name": "Canada",
      "dial": "+1"
    },
    {
      "code": "AU",
      "name": "Australia",
      "dial": "+61"
    },
    {
      "code": "NZ",
      "name": "New Zealand",
      "dial": "+64"
    },
    {
      "code": "AE",
      "name": "United Arab Emirates",
      "dial": "+971"
    },
    {
      "code": "TR",
      "name": "Turkey",
      "dial": "+90"
    },
    {
      "code": "INT",
      "name": "International",
      "dial": "+"
    }
  ],
  "booking_time_filters": [
    {
      "key": "morning",
      "startMinute": 480,
      "endMinute": 720,
      "label": {
        "en": "Morning",
        "de": "Vormittags"
      }
    },
    {
      "key": "midday",
      "startMinute": 720,
      "endMinute": 840,
      "label": {
        "en": "Midday",
        "de": "Mittags"
      }
    },
    {
      "key": "afternoon",
      "startMinute": 840,
      "endMinute": 1140,
      "label": {
        "en": "Afternoon",
        "de": "Nachmittags"
      }
    }
  ],
  "booking_timezone_fallbacks": [
    "Europe/Berlin",
    "Asia/Nicosia",
    "Europe/London",
    "Europe/Paris",
    "UTC",
    "America/New_York",
    "America/Los_Angeles",
    "Asia/Dubai"
  ],
  "website_check_summary_refresh": {
    "initialDelayMs": 600,
    "intervalMs": 2000,
    "maxWaitMs": 20000
  }
};
